module.exports = __webpack_public_path__ + "site/img/pp.72bedfa8.png";